import type { FaireProductEntity } from "../../entity_types/product";

export const p_peyjdgbb4w: FaireProductEntity = {
  token: "p_peyjdgbb4w",
  type: "product",
  name: "Thank you To-ma-toes",
  brandToken: "b_cf1d364a",
  brandName: "Hartland Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/8880f42698c142e265ad57b11685a5528a54d5b3fe721e86660dcf6360304190.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07bf0d9386abde901a198ea96116064787ecb4b386e5248a8da3d39dda48f6d7.jpeg",
    "https://cdn.faire.com/fastly/6babce9042888b3e74a17223b7b5afc860e3f8e611046d5204673f5993c2d4f2.jpeg",
  ],
  priceDollars: 2.75,
  description:
    '- 4.25" x 5.5" blank card \n- Comes with a kraft envelope in a protective eco-sleeve\n- 100% post-consumer fiber envelope\n- Offset printed on 100% recycled felt paper in New York',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:50.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
